import type { DeviceModel } from '../../types/deviceModel';
import type { PlacedEquipment } from '../../types';
import { collectLayoutPorts, collectModelPorts } from './layoutPorts';

export function compareLayoutToModel(
  model: DeviceModel,
  config?: PlacedEquipment['config']
): { ok: boolean; details: string } {
  const layoutPorts = collectLayoutPorts(config?.layout);
  if (layoutPorts.length === 0) return { ok: true, details: '' };
  const modelPorts = collectModelPorts(model);
  if (modelPorts.length === 0) return { ok: true, details: '' };
  const key = (p: { number: number; kind?: string; face?: string }) => `${p.face || 'front'}:${p.number}:${p.kind}`;
  const layoutKeys = new Set(layoutPorts.map((p) => key(p)));
  const modelKeys = new Set(modelPorts.map((p) => key(p)));
  let missing = 0;
  layoutKeys.forEach((k) => {
    if (!modelKeys.has(k)) missing += 1;
  });
  modelKeys.forEach((k) => {
    if (!layoutKeys.has(k)) missing += 1;
  });
  if (missing === 0) return { ok: true, details: '' };
  return {
    ok: false,
    details: `${missing} layout port(s) do not match the stored electrical model. Rebuild logic from the layout.`,
  };
}

/** Layout wins: copy the instance face grid into the stored electrical model. */
export function rebuildModelFromLayout(
  model: DeviceModel,
  config?: PlacedEquipment['config']
): DeviceModel {
  const layout = config?.layout;
  if (!layout) return model;
  return {
    ...model,
    layout: {
      ...model.layout,
      ...(layout.simple ? { simple: layout.simple } : {}),
      ...(layout.multiFace ? { multiFace: layout.multiFace } : {}),
      ...(layout.numberingSchemeId ? { numberingSchemeId: layout.numberingSchemeId } : {}),
    },
  };
}
